import React, { useState } from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import { CommonButton } from '../../../../Styles/CommonStyles';
import { useUpdateassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import nameStringFn from '../../../../data/nameStringFn';
import { useAddNewTransactionMutation } from '../../../../features/transactions/transactionsApiSlice';
import { useModifyArrayUserMutation } from '../../../../features/users/usersApiSlice';
import { useUpdateMultipleDocsMutation } from '../../../../features/addassets/addassetfinalApiSlice';

// Styled Components
const Button = styled(CommonButton)`
  padding: 8px 16px;
  min-width: 120px;
  margin-right: 10px;
`;

const ApproveButton = styled(Button)`
  background-color: #4caf50;
`;

const RejectButton = styled(Button)`
  background-color: #f44336;
`;

const RemarkContainer = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-self: flex-start;
`;

const StoreReturnInboxForm = ({ 
  row, 
  remark, 
  setRemark,
  auth,
  user_current_office, 
  getSingleuser,
  handleBack,
  StoreL1_id
}) => {
  const [updateReq, { isLoading: updateLoading }] = useUpdateassetReqMutation();
  const [addTrans] = useAddNewTransactionMutation();
  const [modifyArrayUser] = useModifyArrayUserMutation();
  const [updateMultipleAssetDocs] = useUpdateMultipleDocsMutation();
  

  const handleStoreApproveReturn = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before approving");
      return;
    }

    const transacData = {
      transac_id: row?.uniqueReqId,
      req_id: "",
      asset_id: row?.assets_requested?.[row?.assets_requested?.length - 1]?.data?.map(x => x.id) || [],
      transac_type: row?.curr_sent_to_tag === "ureq_retrn_ind_store_created"? 'userIndAssetRetunStore': 'userOffAssetReturnStore', //Conditionally set this value based on the type of transaction
      indi_asset: row?.curr_sent_to_tag === "ureq_retrn_ind_store_created"? true: false, // Set to true if the transaction is for individual assets
      from_userid: getSingleuser?.[row?.req_creator_id]?.email,
      from_office: row.req_data[0]?.sent_by?.office,
      from_desig: row.req_data[0]?.sent_by?.designation,
      from_store: row?.req_store,
      to_userid: getSingleuser?.[StoreL1_id]?.email,
      to_office: row?.req_store,
      to_desig: getSingleuser?.[StoreL1_id]?.designation?.[row?.req_store],
      to_store: row?.req_store,
      pdfPath: "",
      time_stamp: new Date().toISOString()
    };

    let senttoData = {
      sent_to_tag: "store_return_approved",
      Text: remark,
      action: "Individual Asset Return Request Approved by Store.",
      sent_by: { id: StoreL1_id, name: getSingleuser?.[StoreL1_id]?.name, office: row?.req_store, designation: getSingleuser?.[StoreL1_id]?.designation?.[row?.req_store] },
      sent_to: { id: StoreL1_id, name: getSingleuser?.[StoreL1_id]?.name, office: row?.req_store, designation: getSingleuser?.[StoreL1_id]?.designation?.[row?.req_store] },
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[StoreL1_id])}-${row?.req_store}-${getSingleuser?.[StoreL1_id]?.designation?.[row?.req_store] || 'Unknown'}`,
      time_stamp: new Date(),
      curr_status: "Closed"
    };

    const assetBody = {
      assetIdArray: row?.assets_requested?.[row.assets_requested.length - 1]?.data || [],
      updates: {
        cur_loc: "store",
        last_trans_date: new Date().toISOString(),
        alloc_user: "",
        alloc_ofc: "Not Applicable",
        cur_user_name: "User not Defined",
        indi_issue:false
      }
    }

    const userBody = [
      {
        _id: row?.req_creator_id,
        operation: "remove",
        arrayField: row?.curr_sent_to_tag === "ureq_retrn_ind_store_created"? "indi_assets" : `assets.${row.req_data[0]?.sent_by?.office}`,
        elements: row?.assets_requested?.[row.assets_requested.length - 1]?.data || []
      }
    ] 
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      const res = await updateReq(body);
      const res3 = await modifyArrayUser({ modifications: userBody });
      const res4 = await updateMultipleAssetDocs(assetBody);
      const res5 = await addTrans(transacData);
      alert("Return request has been approved by store and is now closed.");
      handleBack();
    } catch (error) {
      console.error("Error approving request:", error);
      alert("Error approving request. Please try again.");
    }
  };

  const handleStoreRejectReturn = async () => {
    if (!remark.trim()) {
      alert("Please provide a remark before rejecting");
      return;
    }

    let senttoData = {
      sent_to_tag: "store_return_rejected",
      Text: remark,
      action: "Return Request Rejected by Store.",
      sent_by: { id: StoreL1_id, name: getSingleuser?.[StoreL1_id]?.name, office: row?.req_store, designation: getSingleuser?.[StoreL1_id]?.designation?.[row?.req_store] },
      sent_to: { id: row.req_data[0]?.sent_by?.id, name: row.req_data[0]?.sent_by?.name, office: row.req_data[0]?.sent_by?.office, designation: row.req_data[0]?.sent_by?.designation },
      curr_sent_to_string: `${nameStringFn(row.req_data[0]?.sent_by?.id)}-${row.req_data[0]?.sent_by?.office}-${row.req_data[0]?.sent_by?.designation || 'Unknown'}`,
      time_stamp: new Date(),
      curr_status: "Rejected"
    };
    
    const body = { id: row?._id, senttoData: senttoData };
    
    try {
      await updateReq(body);
      alert("Return request has been rejected by store.");
      handleBack();
    } catch (error) {
      console.error("Error rejecting request:", error);
      alert("Error rejecting request. Please try again.");
    }
  };

  return (
    <>
      <RemarkContainer>
        <TextField
          label="Remarks"
          multiline
          rows={4}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          fullWidth
        />
      </RemarkContainer>

      <ButtonsWrapper>
        <ApproveButton onClick={handleStoreApproveReturn}>
          Approve Return
        </ApproveButton>
        <RejectButton onClick={handleStoreRejectReturn}>
          Reject
        </RejectButton>
      </ButtonsWrapper>
    </>
  );
};

export default StoreReturnInboxForm; 